/*@ngInject*/
const ChatRoomRepository = function (baseRepository) {
    angular.extend(this, baseRepository);

    this.setChatVisibility = function (isVisible) {
        let url = '/rest/ChatRoom/setVisibility',
            config = {
                params: {
                    isVisible: isVisible
                }
            };
        return this.get(url, config);
    };

    this.enter = function (submissionId) {
        let url = '/rest/ChatRoom/' + submissionId + '/enter';
        return this.post(url);
    };

    this.leave = function (submissionId) {
        let url = '/rest/ChatRoom/' + submissionId + '/leave';
        return this.post(url);
    };

    this.getChatNotificationRecipients = function (submissionId) {
        let url = '/rest/ChatRoom/chatNotificationRecipients',
            config = {
                params: {
                    submissionUri: 'com.firstbest.underwriting.submission.Submission:' + submissionId
                }
            };

        return this.get(url, config);
    };
};

angular.module('umCore')
    .service('chatRoomRepository', ChatRoomRepository);
